//
//
//
//
//
//
//
//
//
//
//

import {
  faUserCircle,
  faFileCertificate,
  faDollarSign,
} from '@fortawesome/pro-regular-svg-icons';

import PageTabs from '@/components/core/elements/PageTabs.vue';

export default {
  name: 'AboutTabs',
  components: {
    PageTabs,
  },
  props: {
    activeTab: {
      validator(value) {
        // The value must match one of these strings
        return ['user-guide', 'license', 'pricing'].includes(value);
      },
      required: true,
    },
  },
  data() {
    return {
      tabs: [
        {
          id: 'user-guide',
          icon: faUserCircle,
          label: this.$t(this.$wbr('nav.user_guide')),
          url: '/begin',
        },
        {
          id: 'license',
          icon: faFileCertificate,
          label: this.$t(this.$wbr('nav.eula')),
          url: '/license',
        },
        {
          id: 'pricing',
          icon: faDollarSign,
          label: this.$t(this.$wbr('nav.pricing')),
          url: '/pricing',
        },
      ],
    };
  },
};
